import {store} from '../../redux/store';
import {hideSettingsModal, showSettingsModal} from './reducer';
import {SettingsModal} from '../../interfaces/connected-components/settingsModal';
import {isWeb} from '../../utils/responsive';

/**
 * Dispatches an action to show the global Settings modal with the provided data.
 * @function
 * @returns {void}
 */
export const openSettingsModal = (props?: SettingsModal): void => {
  store.dispatch(showSettingsModal(props));
};

/**
 * Dispatches an action to close the global Settings modal.
 * @function
 * @returns {void}
 */
export const closeSettingsModal = () => {
  store.dispatch(hideSettingsModal());
};

/**
 * Dispatches an action to toggle the global Settings modal.
 * @function
 * @returns {void}
 */
export const toggleSettingsModal = (props?: SettingsModal) => {
  const {isVisible} = store.getState().settingsModal;
  if (isVisible) {
    store.dispatch(hideSettingsModal());
  } else {
    store.dispatch(showSettingsModal(props));
  }
};
